import { services } from '@ambita/ambita-components-core';

const MODAL_ACTIVE = 'ambita-modal--active';
const MODAL_OVERLAY = 'ambita-modal__overlay';
const classUtils = services.domUtils.classUtils;
const isEscapeKeyPressed = services.domUtils.isEscapeKeyPressed;

export const modalMixin = {
  init() {
    const closeOnClick = (event) => {
      if (classUtils.hasClass(event.target, MODAL_OVERLAY)) {
        this.unmount();
      }
    };

    const closeOnEscape = (event) => {
      if (isEscapeKeyPressed(event)) {
        this.unmount();
      }
    };

    this.on('mount', () => {
      let overlayElement = this.root.querySelector(`.${MODAL_OVERLAY}`);
      if (!overlayElement && classUtils.hasClass(this.root, MODAL_OVERLAY)) {
        overlayElement = this.root;
      }
      if (overlayElement) {
        overlayElement.setAttribute('tabindex', '-1');
        overlayElement.focus();

        overlayElement.addEventListener('click', closeOnClick);
      }
      document.body.addEventListener('keyup', closeOnEscape);
      classUtils.addClass(document.body, MODAL_ACTIVE);
    });

    this.on('unmount', () => {
      document.body.removeEventListener('keyup', closeOnEscape);
      classUtils.removeClass(document.body, MODAL_ACTIVE);
    });
  },

  closeModal() {
    this.unmount();
  }
};

export default modalMixin;
